import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {MsalService} from '@azure/msal-angular';
import {FIUStatusEnum, UserStatusEnum} from '@esa/api';
import {select, Store} from '@ngrx/store';
import {Observable, of} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import {UsersActions} from '../store/actions';
import {UsersSelectors} from '../store/selectors';

@Injectable({
  providedIn: 'root'
})
export class ActiveFiuGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
    private msalService: MsalService
  ) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    // Without an MSAL account there's no logged-in user to check the FIU status of - and
    // dispatching this unconditionally races MsalGuard's own login redirect (both try to
    // trigger interaction at once, which MSAL rejects instead of completing the redirect).
    if (this.msalService.instance.getAllAccounts().length === 0) {
      return of(true);
    }

    this.store.dispatch(UsersActions.getLoggedInUser());

    return this.store.pipe(
      select(UsersSelectors.getLoggedInUser),
      filter(user => user !== null),
      take(1),
      map(user => {
        const roleName = user?.role?.roleName?.toLowerCase();
        const isPlatformAdministrator = roleName === 'admin' || roleName === 'super admin';
        const isInactiveFiu = user?.fiu?.fiuStatus == FIUStatusEnum.IN_ACTIVE;

        if(user?.userStatus != UserStatusEnum.DISABLED && isInactiveFiu && !isPlatformAdministrator) {
          return this.router.createUrlTree(['/access-restricted']);
        }

        return true;
      })
    );
  }
}
